<template>
  <section class="section" id="pll-section">
    <!-- Optional Filter Buttons -->
    <!-- <PLLFilterButtons
      :filters="pllCategories"
      :active-filter="activeFilter"
      @filter-change="setFilter"
    /> -->

    <!-- Algorithm Grid -->
    <div class="grid-container">
      <!-- Info Card -->
      <div class="grid-item info-card">
        <h2 class="mainColor"><b>PLL</b></h2>

        <div class="exampleText">
          <p class="exampleText">Permutation of Last Layer</p>
          <p>
            <b>[SX] = R U R'<span class="mainColor2"> U'</span></b>
          </p>
          <p>
            <b>[sh] = R' F R F'</b>
          </p>
          <a href="#home-section">Go to the top</a><br />
          <a href="#f2l-section">Go to F2L</a><br />
          <a href="#oll-section">Go to OLL</a><br />
        </div>
      </div>

      <!-- PLL Cards -->
      <PLLCard
        v-for="algo in visibleAlgorithms"
        :key="algo.id"
        :number="algo.number"
        :name="algo.name"
        :image="algo.image"
        :algorithm="algo.algorithm"
        :alternative-algorithm="algo.alternativeAlgorithm"
        :note="algo.note"
      />
    </div>

    <!-- Footer Links -->
    <!-- Footer Links -->
    <div class="text-warning">
      <div class="text-warning">
        Check also:
        <a href="https://jperm.net/algs/pll" target="_blank" rel="noopener">
          jperm.net/algs/pll
        </a>
      </div>
      <div>
        This is a copy of official GAN site with some improvements for my
        personal use only!<a
          href="https://www.gancube.com/3x3x3-cfop-guide-of-gancube"
        >
          Official GAN site
        </a>
      </div>
      <div>
        <a href="#home-section">Go to the top</a><br />
        <a href="#f2l-section">Go to F2L</a><br />
        <a href="#oll-section">Go to OLL</a><br />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { pllAlgorithms } from './data/pllData';
import PLLCard from './PLLCard.vue';

// Just show all algorithms without filtering
const visibleAlgorithms = computed(() => pllAlgorithms);
</script>

<style scoped>
.section {
  margin: 0 auto 20px;
  padding: 16px 0px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  letter-spacing: 3px;
  margin-bottom: 20px;
}

.info-card {
  background-color: #f4fbfe;
  text-align: left;
  padding: 20px;
  text-align: center;
}

.exampleText {
  color: black;
}

.mainColor {
  color: #f08200;
}

.mainColor2 {
  color: #0075ce;
}

.text-warning {
  text-align: center;
  margin-top: 20px;
  padding: 15px;
  color: #856404;

  border-radius: 4px;
}

.text-warning div {
  margin: 10px 0;
}

@media (max-width: 800px) {
  .grid-container {
    grid-template-columns: 1fr;
  }
}
</style>
